const baseURL = process.env.NEXT_PUBLIC_API_BASE_URL;

const ApiPath = {
  baseURL,

  //global path
  setting: (settingsKey) => `/get-settings?key=${settingsKey}`,
  allSettings: `/get-settings`,
  allCurrency: `/get-currencies`,
  allCountry: `/get-countries`,
  currencyConvert: (charge, walletCode) =>
    `/convert/${charge}/${walletCode}/true`,
  exchangeConvert: (charge, toWalletCode, fromWalletCode) =>
    `/convert/${charge}/${toWalletCode}/true/${fromWalletCode}`,
  registerFieldsValidation: `/get-register-fields/user`,
  navigation: `/navigations-data`,

  //authentication path
  // login: `/auth/agent/login`,
  register: `/auth/user/register`,
  forgetPassword: `/auth/user/forgot-password`,
  resetVerifyOtp: `/auth/user/reset-verify-otp`,
  user: `/auth/user/get`,
  emailVerify: `/auth/user/send-verify-email`,
  verificationValidate: `/auth/user/validate-verify-email`,
  login: `/auth/user/login`,
  logout: `/auth/user/logout`,
  userProfile: `/user/settings/profile`,
  changePassword: `/user/settings/change-password`,
  updatePersonalInfo: `/auth/user/personal-info-update`,
  documentTypes: `/user/kyc`,
  idVerification: `/user/kyc`,
  kycHistory: `/user/kyc/history`,
  qrCodeGenerate: `/user/settings/2fa/generate`,
  enable2FA: `/user/settings/2fa/enable`,
  disable2FA: `/user/settings/2fa/disable`,
  twoFaVerification: `/auth/user/2fa/verify`,
  resetPassword: `/auth/user/reset-password`,

  //page data path
  homePageData: `/home-data`,
  pageData: (pageName) => `/page-data/${pageName}`,
  blogs: `/blogs`,
  blogDetails: (blogId) => `/blog-details/${blogId}`,
  subscribe: `/subscribe-now`,
  contactUs: `/submit-contact-form`,
  languages: `/get-languages`,

  //dashboard path
  dashboard: `/dashboard`,
  dashboardData: `/user/dashboard`,
  dashboardStatsData: `/user/statistics`,
  notifications: `/get-notifications`,
  markAsReadNotification: `/mark-as-read-notification`,
  transactionChart: `/user/activity-chart`,
  wallets: `/user/wallets`,
  deleteWallet: (walletId) => `/user/wallets/${walletId}`,
  transactions: `/user/transactions`,
  transactionsTypes: `/get-transaction-types-and-statuses`,
  qrCode: `/user/qrcode`,
  requestMoneyReceived: `/user/request-money/history`,
  requestMoneyResID: (id) => `/user/request-money/${id}/action`,
  createInvoice: `/user/invoices`,
  invoiceID: (invoiceId) => `/user/invoices/${invoiceId}`,
  getMethods: `/user/add-money`,
  paymentSettings: `/user/payment/settings`,
  makePayment: `/user/payment/make`,
  requestMoneyConfig: `/user/request-money/config`,
  requestMoney: `/user/request-money`,
  transferConfig: `/user/transfer/config`,
  createBeneficiary: `/user/beneficiaries`,
  beneficiaryID: (id) => `/user/beneficiaries/${id}`,
  transferMoney: `/user/transfer`,
  cashoutConfig: `/user/cashout/config`,
  cashout: `/user/cashout`,
  withdrawAccount: `/user/withdraw-accounts`,
  withdrawAccountID: (accountId) => `/user/withdraw-accounts/${accountId}`,
  withdraw: `/user/withdraw`,
  withdrawMethods: `/user/withdraw-accounts/methods/list`,
  exchangeConfig: `/user/exchange/config`,
  exchange: `/user/exchange`,
  giftHistory: `/user/gifts/history`,
  redeemGiftCode: `/user/gifts/redeem`,
  giftConfig: `/user/gifts/config`,
  createGift: `/user/gifts`,
  referralInfo: `/user/referral/info`,
  referredFriends: `/user/referral/direct`,
  referralTree: `/user/referral/tree`,
  supportTicket: `/user/ticket`,
  supportChat: (chatId) => `/user/ticket/${chatId}`,
  replyChat: (chatId) => `/user/ticket/reply/${chatId}`,
  closeSupportTicket: (chatId) => `/user/ticket/action/${chatId}`,
  createSupportTicket: `/user/ticket`,
  billPaymentCountry: (service) => `/get-bill-countries/${service}`,
  billPaymentServiceByCountry: (country, service) =>
    `/user/pay-bill/services/${country}/${service}`,
  billPayment: `/user/pay-bill`,
  billPaymentHistory: `/user/pay-bill/history`,
  generatePasscode: `/user/passcode`,
  disablePasscode: `/user/passcode/disable`,
  changePasscode: `/user/passcode/change`,
  verifyPasscode: `/user/passcode/verify`,
  virtualCards: `/user/cards`,
  virtualCardDetails: (cardId) => `/user/cards/${cardId}`,
  virtualCardTopup: (cardId) => `/user/cards/balance/topup/${cardId}`,
  virtualCardProviders: `/get-card-providers`,
  virtualCardHolders: `/user/cardholders`,
  virtualCardStatus: (cardId) => `/user/cards/update-status/${cardId}`,
  virtualCardTransactions: (cardId) => `user/cards/transactions/${cardId}`,
  bsiCardDetails: (cardId) => `/user/bsicards/cards/details/${cardId}`,
  createPaymentLink: `/user/payment-links/create`,
  paymentLinkList: `/user/payment-links/history`,
  giftCards: `/user/gift-cards/products`,
  giftCardCategories: `/user/gift-cards/categories`,
  giftCardsCountries: `/user/gift-cards/countries`,
  giftCardDetails: (productId) =>
    `/user/gift-cards/product-details/${productId}`,
  giftCardPayment: `/user/gift-cards/product/order`,
  giftCardPurchaseHistory: `/user/gift-cards/purchased-history`,
  paymentMethodList: `/user/p2p/payment-accounts`,
  paymentMethodID: (id) => `/user/p2p/payment-accounts/${id}`,
  paymentMethods: `/user/p2p/payment-methods`,
  paymentMethodStore: `/user/p2p/payment-accounts`,
  editPaymentMethod: (id) => `/user/p2p/payment-accounts/${id}`,
  p2pHeightOrderPrice: `/user/p2p/ads/highest-order-price`,
  p2pAdsCreate: `/user/p2p/ads`,
  p2pMyAds: `/user/p2p/ads`,
  p2pAdsID: (id) => `/user/p2p/ads/${id}`,
  p2pAdsStatusChange: (id) => `user/p2p/ads/${id}/status-update`,
  p2pMarketplaceAdds: `/user/p2p/marketplace`,
  p2pMarketConfig: `/user/p2p/marketplace/config`,
  p2pAdDetails: (id) => `/user/p2p/ads/${id}`,
  myPaymentMethodList: (id) => `/user/p2p/ads/${id}/payment-methods`,
  p2pEligibleUser: `/user/p2p/ads/eligibility`,
  p2pOrderCreate: `/user/p2p/orders`,
  p2pMarketplaceDetails: (id) => `/user/p2p/marketplace/${id}`,
  p2pOrderDetails: (id) => `/user/p2p/orders/${id}`,
  p2pOrderChat: (id) => `/user/p2p/orders/${id}/messages`,
  p2pOrderCancel: (id) => `/user/p2p/orders/${id}/cancel`,
  p2pOrderMarkPaid: (id) => `/user/p2p/orders/${id}/mark-paid`,
  p2pOrderDispute: (id) => `/user/p2p/orders/${id}/dispute`,
  p2pOrderPaymentMethodChange: (id) => `/user/p2p/orders/${id}/payment-method`,
  p2pMyOrders: `/user/p2p/orders`,
  p2pOrderMarkReleased: (id) => `user/p2p/orders/${id}/release`,
  p2pVerifyTraderStatus: `/user/p2p/verified-trader-application/status`,
  p2pVerifyTraderApply: `user/p2p/verified-trader-application/apply`,

  dpsPlans: `/user/dps`,
  dpsSubscribe: `/user/dps`,
  dpsMyPlans: `/user/dps/history`,
  dpsCancel: (dpsId) => `/user/dps/${dpsId}`,
  dpsDetails: (dpsId) => `/user/dps/details/${dpsId}`,
  dpsInstallments: (dpsId) => `user/dps/installments/${dpsId}`,
  dpsIncrease: `/user/dps/increase`,
  dpsDecrease: `/user/dps/decrease`,

  fdrPlans: `/user/fdr`,
  fdrSubscribe: `/user/fdr`,
  fdrMyPlans: `/user/fdr/history`,
  fdrCancel: (fdrId) => `/user/fdr/${fdrId}`,
  fdrDetails: (fdrId) => `/user/fdr/details/${fdrId}`,
  fdrInstallments: (fdrId) => `user/fdr/installments/${fdrId}`,
  fdrIncrease: `/user/fdr/increase`,
  fdrDecrease: `/user/fdr/decrease`,

  loanPlans: `/user/loan/plans`,
  loanPlanDetails: (id) => `/user/loan/plan-details/${id}`,
  loanApply: `/user/loan/subscribe`,
  loanMyPlans: `/user/loan/history`,
  loanCancel: `/user/loan/cancel`,
  loanDetails: (loanId) => `/user/loan/details/${loanId}`,
  loanInstallments: (loanId) => `user/loan/installments/${loanId}`,
  payLoanInstallment: `/user/loan/pay-installment`,
};

export default ApiPath;
